const SLIDERS = document.querySelectorAll('[data-slider-arrows]');
// console.log(SLIDERS);
[...SLIDERS].forEach(
    function(DIV){
        // BUILD THE ARROWS FOR THIS UNLESS IT SPECIFICALLY SAYS "false" NOT TO.
        if(DIV.getAttribute('data-slider-arrows') != 'false' ){
            buildArrowsForThisSlider(DIV);
        }
    }
);
 

function buildArrowsForThisSlider(_DIV){
    let DIV = _DIV; 
    let WRAPPER = DIV.parentNode;
    
    let buttonLeft = document.createElement("button");
    buttonLeft.type = 'button';
    buttonLeft.className = 'slider-button text-black bg-white absolute left-8 inset-y-1/3 z-50 rounded-full h-10 w-10 flex flex-col items-center justify-center cursor-pointer ';
    // buttonLeft.innerHTML = '<img src="/wp-content/themes/tombras/assets/icons/chevron-left.svg" />';
    buttonLeft.innerHTML = `<svg width="13" height="19" >
                                <path d="M11.112 1L3 9.112l8.112 8.113" stroke="currentColor" stroke-width="3" fill="none" fill-rule="evenodd"/>
                            </svg>`;
    
    let buttonRight = document.createElement("button");
    buttonRight.type = 'button';
    buttonRight.className = 'slider-button text-black bg-white absolute inset-y-1/3 right-8 z-50 rounded-full h-10 w-10 flex flex-col items-center justify-center cursor-pointer ';
    // buttonRight.innerHTML = '<img class="w-10 h-auto" src="/wp-content/themes/tombras/assets/icons/chevron-right.svg" />';
    buttonRight.innerHTML = `<svg class="relative " width="13" height="19">
                                <path d="M1 1l8.112 8.112L1 17.225" stroke="currentColor" stroke-width="3" fill="none" fill-rule="evenodd"/>
                            </svg>`;
    
    WRAPPER.append(buttonLeft);
    WRAPPER.append(buttonRight);

    buttonLeft.onclick = function(){
        slideLeft(buttonLeft, buttonRight, DIV);
    } 

    buttonRight.onclick = function(){
        slideRight(buttonLeft, buttonRight, DIV);
    } 



    checkButtons(buttonLeft, buttonRight, DIV);

}

function checkButtons(_btnLeft, _btnRight, _DIV){
    
    // let maxScrollLeft = _DIV.scrollWidth - _DIV.clientWidth;

    setTimeout( function(){
        if(_DIV.scrollLeft == 0){
            _btnLeft.classList.add('hidden');
        }else{
            _btnLeft.classList.remove('hidden');
        }
            
        // let maxScrollLeft = _DIV.scrollWidth - _DIV.clientWidth;
       
        if(_DIV.scrollLeft ==  (_DIV.scrollWidth - _DIV.clientWidth)   ){
            _btnRight.classList.add('hidden');
        }else{
            _btnRight.classList.remove('hidden');
        }
    
    }, 500 );

}


function slideLeft(_btnLeft, _btnRight, _DIV){
    let W = _DIV.firstElementChild.clientWidth;
    // DIV.scrollLeft += W;
    // DIV.scrollBy({ top:0, left: W, behavior: 'smooth' });
    _DIV.scrollBy({ left: -W, behavior: 'smooth' });
    
    checkButtons(_btnLeft, _btnRight, _DIV)
}


function slideRight(_btnLeft, _btnRight, _DIV){
    let W = _DIV.firstElementChild.clientWidth;
    // DIV.scrollLeft -= W;
    _DIV.scrollBy({ left: W, behavior: 'smooth' });

    // let maxScrollLeft = _DIV.scrollWidth - _DIV.clientWidth;
    
    checkButtons(_btnLeft, _btnRight, _DIV)

}





export {};
